import { parsePhoneNumber } from 'libphonenumber-js';

export const ConvertPriceToString = (value, currency) => {
    const tmpCurrency = currency ?? 'PLN'
    const numericValue = Number(value) || 0

    let priceString = numericValue.toLocaleString('pl-PL', {
        style: 'currency',
        currency: tmpCurrency,
        useGrouping: true,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
    if (currency === null) {
        priceString = priceString.replace('zł', ``)
    } else if (tmpCurrency === 'PLN') {
        priceString = priceString.replace(/\s*zł/, ` zł`)
    }
    return priceString;
}

export const CapitalizeFirstLowercaseRest = str => {
    let result = str
    try {
        result = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    } catch (error) {
        result = ''
    }
    return result
}

export function capitalizeFirstLetter(value) {
    return value.length ? value.charAt(0).toUpperCase() + value.slice(1) : "";
}

export function datePlus7DaysYYYYMMDDHHmmss() {
    const d = new Date();
    d.setDate(d.getDate() + 7); // +7 dni [web:52][web:57]

    const pad = (n) => String(n).padStart(2, "0"); // zerowanie do 2 cyfr [web:54]

    return (
        d.getFullYear() +
        pad(d.getMonth() + 1) +
        pad(d.getDate()) +
        pad(d.getHours()) +
        pad(d.getMinutes()) +
        pad(d.getSeconds())
    );
}

/* export function dateToYYYYMMDD(date = new Date()) {
    const d = (date instanceof Date) ? date : new Date(date);
    return d.toLocaleDateString().slice(0, 10).replaceAll("-", "");
} */

export function dateToYYYYMMDD(date = new Date()) {
    const d = (date instanceof Date) ? date : new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
}

export function dateToYYYYMMDDHHMMSS(date = new Date()) {
    const d = (date instanceof Date) ? date : new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
}

/**
 * DK: Funkcja formatująca numer telefonu do formatu międzynarodowego.
 * @param {string} value - Numer telefonu do sformatowania.
 * @returns {string} - Sformatowany numer telefonu w formacie międzynarodowym
 */
export function formatPhoneNumber(value) {
    if (!value) {
        return ''
    }
    const digits = value.replace(/\D/g, '')
    if (!digits) {
        return value
    }
    try {
        const phone = parsePhoneNumber('+' + digits)
        if (phone && phone.isValid()) {
            return phone.formatInternational()
        }
    } catch { }
    return '+' + digits
}